<template>

<div>
    <div class="jumbotron page-header d-flex justify-content-center align-items-center">
        <div class="inner-page-header text-center pb-3">
            <span class="icon icon-armchair"></span>
             <h1>ERROR 404</h1>
        </div>
    </div>

    <div class="main-page-content">
        <div class="container">
            <div class="row pt-4 mt-5">
                <div class="col-12 text-center">
                   
                    <h3 class="text-center mb-2">
                        Страницата не беше открита.
                    </h3>
                    <p class="text-center mb-4">
                        За съжаление страницата, която търсиш, не беше открита.
                    </p>

                    <a href="/" class="btn btn-outline-primary btn-lg">
                        Начална страница
                    </a>

                    
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {

        },

        data() {
            return {

            }
        },

        methods : {

        }

    }
</script>
